export default "__VITE_ASSET__dW8mIIkV__"